<template>
  <section class="page-otcTrade main-second-bg">
    <div class="page-otcTrade-content">
      <div class="page-otcTrade-bar">
        <!-- 页面标题 -->
        <div class="pageTitle gray-10-bd main-cl">{{ pageTitle }}</div>
        <!-- 头部 -->
        <div class="headArea gray-10-bd">
          <div class="left">
            <!-- 头像 -->
            <div class="avataAndName">
              <div class="avatar blue-bg white-cl" @click="goUser">
                <div v-if="axiosObj.imageUrl">
                  <img :src="axiosObj.imageUrl" alt="" />
                </div>
                <div v-else-if="axiosObj.otcNickName">{{ axiosObj.otcNickName[0] }}</div>
                <div
                  class="lineIcon"
                  :class="axiosObj.loginStatus === 1 ? 'green-bg' : 'gray-bg'"
                ></div>
              </div>
              <!-- 名称/在线状态 -->
              <div class="otcTrade-user">
                <div class="otcTrade-userName main-cl" :title="axiosObj.otcNickName">
                  {{ axiosObj.otcNickName }}
                  <span v-html="userVip" style="margin-left: 2px"></span>
                </div>
                <div
                  class="otcTrade-userStatus"
                  :class="axiosObj.loginStatus === 1 ? 'green-cl' : 'gray-cl'"
                >
                  {{ axiosObj.loginStatus === 1 ? $t("otcTrade.inLine") : $t("otcTrade.outLine") }}
                </div>
              </div>
            </div>
            <!-- 交易次数 -->
            <div class="header-even">
              <div class="header-even-value gray-cl">{{ $t("otcTrade.TransactionTimes") }}</div>
              <div class="header-even-key main-cl">{{ axiosObj.dealVolume }}</div>
            </div>
            <!-- 信用度 -->
            <div class="header-even">
              <div class="header-even-value gray-cl">{{ $t("otcTrade.CreditDegree") }}</div>
              <div class="header-even-key main-cl">{{ credit }}</div>
            </div>
            <!-- 历史成交 -->
            <div class="header-even">
              <div class="header-even-value gray-cl">
                {{ $t("otcTrade.his") }}
              </div>
              <!-- 历史成交(折合BTC) -->
              <div class="header-even-key main-cl">{{ axiosObj.turnover | BTCFixD(that) }} BTC</div>
            </div>
          </div>
          <div class="right">
            <!-- 操作 非自己的订单才会有倒计时 -->
            <div class="buttonTimer" v-if="optionsFlag === 'even'">
              <!-- 倒计时 -->
              <span class="main-cl">{{ $t("otcTrade.CountDown") }}：</span>
              <span class="red-cl">{{ time }}s</span>
            </div>
          </div>
        </div>
        <!-- 主体信息 -->
        <div class="messageInfoArea gray-10-bd">
          <div class="title main-cl">{{ messageTitle }}</div>
          <div class="infoContent">
            <div class="left">
              <!-- 单价 -->
              <div class="infoItem">
                <div class="label gray-cl">{{ $t("otcTrade.price") }}</div>
                <div class="value main-cl">{{ axiosObj.price | payFixD(that) }} {{ axiosObj.payCoin }}</div>
              </div>
              <!-- 数量 -->
              <div class="infoItem">
                <div class="label gray-cl">{{ $t("otcTrade.volume") }}</div>
                <div class="value main-cl">
                  {{ axiosObj.volumeBalance | coinFixD(that) }} {{ axiosObj.coin }}
                </div>
              </div>
              <!-- 交易限额 -->
              <div class="infoItem">
                <div class="label gray-cl">{{ $t("otcTrade.TradingLimit") }}</div>
                <div class="value main-cl">
                  {{ axiosObj.minTrade | payFixD(that) }} - {{ axiosObj.maxTrade | payFixD(that) }}
                  {{ axiosObj.payCoin }}
                </div>
              </div>
            </div>
            <div class="right">
              <!-- 付款时限 -->
              <div class="infoItem">
                <div class="label gray-cl">{{ $t("otcTrade.TimeLimitPayment") }}</div>
                <div class="value main-cl">{{ axiosObj.limitTime }} {{ $t("otcTrade.min") }}</div>
              </div>
              <!-- 收款方式 -->
              <div class="infoItem">
                <div class="label gray-cl">{{ sidePay }}</div>
                <div class="value main-cl">
                  <c-otcPayIcon
                    class="otcTrade-otcPayIcon"
                    :imgUrl="item.icon"
                    v-for="(item, index) in payments"
                    :payment="item.key"
                    :key="index"
                  />
                </div>
              </div>
              <!-- 商家备注 -->
              <div class="infoItem">
                <div class="label gray-cl">{{ $t("otcTrade.MerchantRemarks") }}</div>
                <div class="value main-cl">
                  <!-- 商家备注 -->
                  <span v-if="isShowEscription">{{ axiosObj.description }}</span>
                  <!-- 无 -->
                  <span v-else>{{ $t("otcTrade.none") }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 操作 自己的订单 -->
        <div class="otcTrade-options-myself" v-if="optionsFlag === 'myself'">
          <div>
            <!-- 返回法币交易大厅 -->
            <c-button type="solid" paddingW="24px" height="40px" @click="goHall">
              {{ fiatTradeOpen ? $t("assets.b2c.otcShow.goHall") : $t("otcTrade.goHall") }}
            </c-button>
            <!-- 关闭广告 -->
            <c-button
              v-if="axiosObj.status && axiosObj.status !== 4"
              type="text"
              className="textButton"
              paddingW="24px"
              height="40px"
              @click="closeTrade"
            >
              {{ $t("otcTrade.close") }}
            </c-button>
          </div>
          <p class="myself-tip">{{ axiosObj.tip }}</p>
        </div>
        <!-- 操作 非自己的订单 -->
        <div class="otcTrade-options-trade" v-if="optionsFlag === 'even'">
          <div class="options-trade-title b-1-cl">
            {{
              axiosObj.side === "SELL" ? $t("otcTrade.PurchaseAmount") : $t("otcTrade.AmountSale")
            }}
          </div>
          <div class="options-trade-form clearfix">
            <div class="leftInp">
              <c-inputLine
                :promptText="leftInputOptions.promptText"
                name="leftInp"
                :value="leftInp"
                :errorHave="true"
                :errorText="leftInpObj.errorText"
                :errorFlag="leftInpObj.errorFlag"
                :warningText="leftInputOptions.warningText"
                @onchanges="inputLineChange"
                newStyleFormat
              >
                <!-- 全部 -->
                <c-button
                  type="text"
                  height="30px"
                  style="width: 26px;padding: 0;transform: translate(0px, -1px);"
                  v-if="axiosObj.side === 'BUY'"
                  @click="inputAll('left')"
                  >{{ $t("otcTrade.all") }}
                </c-button>
              </c-inputLine>
            </div>
            <div class="tradeIcon">
              <svg-icon class="icon icon-16" icon-class="icon-trans"></svg-icon>
            </div>
            <div class="rightInp">
              <c-inputLine
                :promptText="rightInputOptions.promptText"
                name="rightInp"
                :value="rightInp"
                :errorHave="true"
                :errorText="rightInpObj.errorText"
                :errorFlag="rightInpObj.errorFlag"
                :warningText="rightInputOptions.warningText"
                @onchanges="inputLineChange"
                newStyleFormat
              >
                <c-button
                  type="text"
                  height="30px"
                  style="width: 26px;padding: 0;transform: translate(0px, -1px);"
                  v-if="axiosObj.side === 'SELL'"
                  @click="inputAll('right')"
                  >{{ $t("otcTrade.all") }}
                </c-button>
              </c-inputLine>
            </div>
          </div>
          <!-- 资金密码 buy时 -->
          <div class="options-trade-pass" v-if="axiosObj.side === 'BUY'">
            <c-inputLine
              :promptText="$t('otcTrade.pass')"
              name="passCode"
              inputType="password"
              :value="passCode"
              :errorHave="true"
              :errorText="$t('otcTrade.passError')"
              :errorFlag="passErrorFlag"
              @onchanges="inputLineChange"
              style="width: 576px"
              newStyleFormat
            >
            </c-inputLine>
          </div>
          <!-- 提交BUtton -->
          <div class="options-trade-button">
            <!-- 立即出售 -->
            <c-button
              v-if="axiosObj.side === 'BUY'"
              paddingW="32px"
              marginTop="18px"
              width="260px"
              :disabled="mySellBtnDisabled"
              :loading="btnLoading"
              @click="BtnClick"
              style="font-size: 16px;"
              >{{ $t("otcTrade.ImmediateSale") }}
            </c-button>
            <!-- 立即购买 -->
            <c-button
              v-if="axiosObj.side === 'SELL'"
              paddingW="32px"
              marginTop="50px"
              width="260px"
              :disabled="myBuyBtnDisabled"
              :loading="btnLoading"
              @click="BtnClick"
              style="font-size: 16px;"
              >{{ $t("otcTrade.ImmediatePurchase") }}
            </c-button>
          </div>
          <div class="b-7-cl warning" v-if="axiosObj.side === 'SELL' && windFlag">
            {{ !fiatTradeOpen ? $t("otcTrade.warning") : $t("assets.b2c.otcShow.otcTradeWarning") }}
          </div>
          <c-otcReminder v-if="optionsFlag === 'even'" />
        </div>
        <!-- 关闭广告二次确认弹窗 -->
        <c-dialog
          :showFlag="closeTradeFlag"
          :titleText="$t('otcTrade.closeTitle')"
          :confirmLoading="closeTradeConfirmLoading"
          @confirm="closeTradeConfirm"
          @close="closeTradeClose"
        >
          <div class="closeTrade-dialog">{{ $t("otcTrade.closeWarning") }}</div>
        </c-dialog>
      </div>
    </div>
  </section>
</template>

<script>
import { fixD, fixInput, getCoinShowName } from '@/utils';

export default {
  data() {
    return {
      orderId: null, // 订单id
      userId: null, // 用户id
      axiosObj: {},
      axiosReady: false,
      closeTradeConfirmLoading: false, // 关闭广告弹窗 -- 确认按钮loading
      closeTradeFlag: false, // 关闭广告弹窗变量
      leftInp: '', // 左侧input
      rightInp: '', // 右侧input
      passCode: '', // 资金密码
      btnLoading: false,
      timer: null, // 倒计时 计时器
      time: 60, // 倒计时
    };
  },
  filters: {
    payFixD(v, that) {
      return fixD(v, that.priceFix);
    },
    coinFixD(v, that) {
      return fixD(v, that.volumeFix);
    },
    BTCFixD(v, that) {
      return fixD(v, that.btcFix);
    },
  },
  computed: {
    fiatTradeOpen() {
      const base = this.$store.state.baseData.publicInfo;
      if (base && base.switch && base.switch.fiat_trade_open === '1') {
        return true;
      }
      return false;
    },
    publicInfo() {
      return this.$store.state.baseData.publicInfo;
    },
    windFlag() {
      let flag = false;
      if (
        this.publicInfo
        && this.publicInfo.switch
        && this.publicInfo.switch.wind_control_switch
        && this.publicInfo.switch.wind_control_switch.toString() === '1'
      ) {
        flag = true;
      }
      return flag;
    },
    userInfo() {
      return this.$store.state.baseData.userInfo;
    },
    /**
     * 商户状态，0:未认证，1：普通商户，2：超级商户，3：等待释放
     */
    userVip() {
      let str = '';
      // if (this.userInfo && this.userInfo.otcCompanyInfo) {
      //   if (Number(this.userInfo.otcCompanyInfo.status)) {
      if (this.axiosObj.companyLevel === 1) {
        str = `<svg class="icon icon-16" aria-hidden="true">
              <use xlink:href="#icon-c_16"></use>
            </svg>`;
      } else if (this.axiosObj.companyLevel === 2) {
        str = `<svg class="icon icon-16" aria-hidden="true">
              <use xlink:href="#icon-c_17"></use>
            </svg>`;
      }
      //   }
      // }
      return str;
    },
    // 信用度
    credit() {
      let str = '';
      if (this.axiosObj.creditGrade) {
        str = `${(this.axiosObj.creditGrade * 100).toFixed(2)}%`;
      }
      return str;
    },
    // 我要出售(立即出售) 按钮
    mySellBtnDisabled() {
      let flag = true;
      if ((this.leftInpObj.flag && this.rightInpObj.flag && this.passFlag) || this.btnLoading) {
        flag = false;
      }
      return flag;
    },
    // 我要购买(立即购买) 按钮
    myBuyBtnDisabled() {
      let flag = true;
      if ((this.leftInpObj.flag && this.rightInpObj.flag) || this.btnLoading) {
        flag = false;
      }
      return flag;
    },
    leftInpObj() {
      // 我要出售 当前该输入框为数字货币
      if (this.axiosObj.side === 'BUY') {
        // 当前框为0 或者没有数量时
        if (parseFloat(this.leftInp) === 0 || this.leftInp.length === 0) {
          return {
            flag: false,
            errorFlag: false,
            errorText: '',
          };
          // 当前框的值 大于 剩余数量
        }
        if (parseFloat(this.leftInp) > parseFloat(this.axiosObj.volumeBalance)) {
          return {
            flag: false,
            errorFlag: true,
            // 下单金额大于该订单数量
            errorText: this.$t('otcTrade.numberError'),
          };
        }
        return {
          flag: true,
          errorFlag: false,
          errorText: '',
        };

        // 我要购买 当前该输入框为法币
      }
      if (this.axiosObj.side === 'SELL') {
        // 当前框为0 或者没有数量时
        if (parseFloat(this.leftInp) === 0 || this.leftInp.length === 0) {
          return {
            flag: false,
            errorFlag: false,
            errorText: '',
          };
          // 当前框的值 小于 最小交易限额
        }
        if (parseFloat(this.leftInp) < parseFloat(this.axiosObj.minTrade)) {
          return {
            flag: false,
            errorFlag: true,
            // 换取数量不得小于最小交易限额
            errorText: this.$t('otcTrade.numberMinError'),
          };
          // 当前框的值 大于 最大交易限额
        }
        if (parseFloat(this.leftInp) > parseFloat(this.axiosObj.maxTrade)) {
          return {
            flag: false,
            errorFlag: true,
            // 换取数量不得大于最大交易限额
            errorText: this.$t('otcTrade.numberMaxError'),
          };
        }
        return {
          flag: true,
          errorFlag: false,
          errorText: '',
        };
      }
      return {
        flag: false,
        errorFlag: false,
        errorText: '',
      };
    },
    rightInpObj() {
      // 我要出售 当前该输入框为法币框
      if (this.axiosObj.side === 'BUY') {
        // 当前框为0 或者没有数量时
        if (parseFloat(this.rightInp) === 0 || this.rightInp.length === 0) {
          return {
            flag: false,
            errorFlag: false,
            errorText: '',
          };
          // 当前框的值 小于 最小交易限额
        }
        if (parseFloat(this.rightInp) < parseFloat(this.axiosObj.minTrade)) {
          return {
            flag: false,
            errorFlag: true,
            // 换取数量不得小于最小交易限额
            errorText: this.$t('otcTrade.numberMinError'),
          };
          // 当前框的值 大于 最大交易限额
        }
        if (parseFloat(this.rightInp) > parseFloat(this.axiosObj.maxTrade)) {
          return {
            flag: false,
            errorFlag: true,
            // 换取数量不得大于最大交易限额
            errorText: this.$t('otcTrade.numberMaxError'),
          };
        }
        return {
          flag: true,
          errorFlag: false,
          errorText: '',
        };

        // 我要购买
      }
      if (this.axiosObj.side === 'SELL') {
        // 当前框为0 或者没有数量时
        if (parseFloat(this.rightInp) === 0 || this.rightInp.length === 0) {
          return {
            flag: false,
            errorFlag: false,
            errorText: '',
          };
          // 当前框的值 大于 剩余数量
        }
        if (parseFloat(this.rightInp) > parseFloat(this.axiosObj.volumeBalance)) {
          return {
            flag: false,
            errorFlag: true,
            // 下单金额大于该订单数量
            errorText: this.$t('otcTrade.numberError'),
          };
        }
        return {
          flag: true,
          errorFlag: false,
          errorText: '',
        };
      }
      return {
        flag: false,
        errorFlag: false,
        errorText: '',
      };
    },
    // passCode 是否复合正则验证
    passFlag() {
      return this.$store.state.regExp.passWord.test(this.passCode);
    },
    // pass框是否为错误状态
    passErrorFlag() {
      if (this.passCode.length !== 0 && !this.passFlag) return true;
      return false;
    },
    leftInputOptions() {
      // 下单金额
      let promptText = this.$t('otcTrade.OrderAmount');
      let warningText = '';
      const {
        side, payCoin, coin, minTrade, maxTrade,
      } = this.axiosObj;
      if (side === 'SELL') {
        // 用 法币 买 数字货币
        promptText += ` (${payCoin})`;
        // 下单金额范围
        warningText = `${this.$t('otcTrade.ScopeOrderAmount')}
         (${fixD(minTrade, this.priceFix)} - ${fixD(maxTrade, this.priceFix)})`;
      } else if (side === 'BUY') {
        // 用 数字货币 换 法币
        promptText += `(${this.getShowCoin(coin)})`;
      }
      return {
        promptText,
        warningText,
      };
    },
    rightInputOptions() {
      // 换取数量
      let promptText = this.$t('otcTrade.QuantityInExchange');
      let warningText = '';
      const {
        side, payCoin, coin, minTrade, maxTrade,
      } = this.axiosObj;
      if (side === 'SELL') {
        // 用 法币 买 数字货币
        promptText += ` (${this.getShowCoin(coin)})`;
      } else if (side === 'BUY') {
        // 用 数字货币 换 法币
        promptText += `(${payCoin})`;
        // 下单金额范围
        warningText = `${this.$t('otcTrade.ScopeOrderAmount')}
          (${fixD(minTrade, this.priceFix)} - ${fixD(maxTrade, this.priceFix)})`;
      }
      return {
        promptText,
        warningText,
      };
    },
    // 操作区域展示的模块 非自己/自己
    optionsFlag() {
      let flag = '';
      if (this.axiosReady) {
        if (this.axiosObj.tip && this.axiosObj.tip.length) {
          flag = 'myself';
        } else {
          flag = 'even';
        }
      }
      return flag;
    },
    that() {
      return this;
    },
    volumeFix() {
      let fix = '';
      const { coin } = this.axiosObj;
      if (
        this.market
        && coin
        && this.market.coinList[coin]
        && this.market.coinList[coin].showPrecision
      ) {
        fix = this.market.coinList[coin].showPrecision;
      }
      return Number(fix);
    },
    btcFix() {
      let fix = '';
      if (this.market && this.market.coinList.BTC && this.market.coinList.BTC.showPrecision) {
        fix = this.market.coinList.BTC.showPrecision;
      }
      return Number(fix);
    },
    priceFix() {
      let fix = this.$store.state.baseData.defaultFiatPrecision;
      const { payCoin, coin } = this.axiosObj;
      if (
        this.market
        && coin
        && payCoin
        && this.market.coinList[coin]
        && this.market.coinList[coin].fiatPrecision
        && this.market.coinList[coin].fiatPrecision[payCoin.toLowerCase()]
      ) {
        fix = this.market.coinList[coin].fiatPrecision[payCoin.toLowerCase()];
      }
      return Number(fix);
    },
    market() {
      return this.$store.state.baseData.market;
    },
    otcPublicInfo() {
      return this.$store.state.baseData.otcPublicInfo;
    },
    pageTitle() {
      const { side } = this.axiosObj;
      return side === 'BUY' ? this.$t('otcTrade.sell') : this.$t('otcTrade.buy');
    },
    // 使用 xx 交易 xxx
    messageTitle() {
      let str = '';
      const { side, coin, payCoin } = this.axiosObj;
      if (side && coin && payCoin) {
        // 使用
        str = `${this.$t('otcTrade.use')}
          ${payCoin}
          ${side === 'BUY' ? this.$t('otcTrade.sell') : this.$t('otcTrade.buy')} ${this.getShowCoin(
  coin,
)}`;
      }
      return str;
    },
    // 收款方式 / 付款方式
    sidePay() {
      // 交易方式
      let str = this.$t('otcTrade.TransactionMode');
      if (this.axiosObj.side) {
        str = this.axiosObj.side === 'BUY'
          ? this.$t('otcTrade.payment')
          : this.$t('otcTrade.Receivables');
      }
      return str;
    },
    // 是否展示商家备注
    isShowEscription() {
      if (this.axiosObj.description && this.axiosObj.description.length) {
        return true;
      }
      return false;
    },
    // 支付方式
    payments() {
      if (this.axiosObj.payments) {
        return this.axiosObj.payments;
      }
      return [];
    },
  },
  watch: {
    optionsFlag(v) {
      if (v === 'even') {
        this.startTime();
      }
    },
    leftInp(v) {
      let fix = 0;
      // 如果该订单为 卖单走法币精度, 买单走数字货币精度
      if (this.axiosObj.side === 'SELL') {
        fix = this.priceFix;
      } else if (this.axiosObj.side === 'BUY') {
        fix = this.volumeFix;
      }
      this.leftInp = fixInput(v, fix);
    },
    rightInp(v) {
      let fix = 0;
      // 如果该订单为 卖单走数字货币币精度, 买单走法币精度
      if (this.axiosObj.side === 'SELL') {
        fix = this.volumeFix;
      } else if (this.axiosObj.side === 'BUY') {
        fix = this.priceFix;
      }
      this.rightInp = fixInput(v, fix);
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  mounted() {
    this.init();
  },
  methods: {
    getShowCoin(v) {
      let str = v;
      if (this.market && this.market.coinList) {
        str = getCoinShowName(v, this.market.coinList);
      }
      return str;
    },
    init() {
      const { orderId, userId } = this.$route.query;
      if (orderId) {
        this.orderId = orderId;
        this.userId = userId;
        this.initOrder();
      }
    },
    startTime() {
      clearInterval(this.timer);
      this.time = 60;
      this.timer = setInterval(() => {
        this.time -= 1;
        if (this.time <= 0) {
          clearInterval(this.timer);
          this.$router.push('/otc');
        }
      }, 1000);
    },
    goUser() {
      if (this.userId) {
        this.$router.push(`/stranger?uid=${this.userId}`);
      }
    },
    BtnClick() {
      // 我要购买
      if (this.axiosObj.side === 'SELL') {
        this.btnLoading = true;
        this.axios({
          url: 'v4/otc/buy_order_save',
          params: {
            advertId: this.orderId,
            price: this.axiosObj.price,
            totalPrice: this.leftInp, // 法币
            type: 'price',
            volume: this.rightInp, // 数字货币
          },
          hostType: 'otc',
        }).then((data) => {
          this.btnLoading = false;
          if (data.code.toString() === '0') {
            this.$bus.$emit('tip', { text: data.msg, type: 'success' });
            this.$router.push(`otcDetailOrder?orderId=${data.data.sequence}`);
          } else {
            this.$bus.$emit('tip', { text: data.msg, type: 'error' });
          }
        });
        // 我要出售
      } else if (this.axiosObj.side === 'BUY') {
        this.btnLoading = true;
        this.axios({
          url: 'v4/otc/sell_order_save',
          params: {
            advertId: this.orderId,
            capitalPword: this.passCode,
            price: String(this.axiosObj.price),
            totalPrice: this.rightInp, // 法币
            type: 'volume',
            volume: this.leftInp, // 数字货币
          },
          hostType: 'otc',
        }).then((data) => {
          this.btnLoading = false;
          if (data.code.toString() === '0') {
            this.$bus.$emit('tip', { text: data.msg, type: 'success' });
            this.$router.push(`otcDetailOrder?orderId=${data.data.sequence}`);
          } else {
            this.$bus.$emit('tip', { text: data.msg, type: 'error' });
          }
        });
      }
    },
    inputAll(type) {
      if (this.axiosObj.volumeBalance) {
        if (type === 'right') {
          this.rightInp = fixD(this.axiosObj.volumeBalance, this.volumeFix);
          this.rightServe();
        } else if (type === 'left') {
          this.leftInp = fixD(this.axiosObj.volumeBalance, this.volumeFix);
          this.leftServe();
        }
      }
    },
    // 返回法币交易大厅
    goHall() {
      this.$router.push('/otc');
    },
    // 关闭广告
    closeTrade() {
      this.closeTradeFlag = true;
    },
    // 关闭广告弹窗 -- 确认
    closeTradeConfirm() {
      this.closeTradeConfirmLoading = true;
      this.axios({
        url: '/otc/close_wanted',
        method: 'post',
        hostType: 'otc',
        params: {
          advertId: this.orderId,
        },
      }).then((data) => {
        this.closeTradeConfirmLoading = false;
        if (data.code.toString() === '0') {
          this.$bus.$emit('tip', { text: data.msg, type: 'success' });
          this.initOrder(); // 重新请求该订单
          this.closeTradeFlag = false; // 关闭弹窗
        } else {
          this.$bus.$emit('tip', { text: data.msg, type: 'error' });
        }
      });
    },
    // 关闭广告弹窗 -- 取消
    closeTradeClose() {
      this.closeTradeFlag = false;
    },
    inputLineChange(value, name) {
      this[name] = value;
      if (name === 'leftInp') {
        this.leftServe();
      } else if (name === 'rightInp') {
        this.rightServe();
      }
    },
    leftServe() {
      // 联动rightinp
      if (this.axiosObj.price) {
        // 当前为法币
        if (this.axiosObj.side === 'SELL') {
          this.rightInp = String(this.leftInp / this.axiosObj.price);
          // 当前为数字货币
        } else if (this.axiosObj.side === 'BUY') {
          this.rightInp = String(this.leftInp * this.axiosObj.price);
        }
      }
    },
    rightServe() {
      // 联动rightinp
      if (this.axiosObj.price) {
        // 当前为数字货币
        if (this.axiosObj.side === 'SELL') {
          this.leftInp = String(this.rightInp * this.axiosObj.price);
          // this.rightInp = fixD(v / this.axiosObj.price, this.priceFix)
          // 当前为法币
        } else if (this.axiosObj.side === 'BUY') {
          this.leftInp = String(this.rightInp / this.axiosObj.price);
        }
      }
    },
    initOrder() {
      this.axios({
        url: 'otc/v4/wanted_detail',
        method: 'post',
        hostType: 'otc',
        params: {
          advertId: this.orderId,
        },
      }).then((data) => {
        if (data.code.toString() === '0') {
          this.axiosReady = true;
          this.axiosObj = data.data;
        } else {
          this.$bus.$emit('tip', { text: data.msg, type: 'error' });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-otcTrade {
  width: 100%;
  border-radius: 4px;
  padding-bottom: 30px;
  margin: 0 auto;

  .pageTitle {
    height: 56px;
    line-height: 56px;
    font-size: 18px;
    padding: 0 24px;
    border-bottom-width: 1px;
    border-bottom-style: solid;
  }

  .headArea {
    height: 96px;
    padding: 16px 24px;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;

    .left {
      flex: 1;
      display: flex;
      align-items: center;
      gap: 40px;

      .avataAndName {
        display: flex;
        align-items: center;
        gap: 8px;

        .avatar {
          display: inline-block;
          width: 30px;
          height: 30px;
          border-radius: 50%;
          text-align: center;
          line-height: 30px;
          font-size: 14px;
          position: relative;
          vertical-align: middle;
          cursor: pointer;

          div {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            overflow: hidden;
          }

          img {
            width: 30px;
            height: 30px;
            display: block;
          }
          .lineIcon {
            position: absolute;
            width: 8px;
            height: 8px;
            right: 1px;
            bottom: 0px;
            border-radius: 50%;
          }
        }

        // 名称/在线状态
        .otcTrade-user {
          display: flex;
          flex-direction: column;

          .otcTrade-userName {
            font-size: 16px;
            height: 22px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            max-width: 100px;
          }

          .otcTrade-userStatus {
            margin-top: 4px;
            font-size: 12px;
          }
        }
      }

      .header-even {
        display: flex;
        flex-direction: column;
        gap: 8px;

        .header-even-value {
          font-size: 12px;
          height: 17px;
          line-height: 17px;
        }

        .header-even-key {
          font-size: 14px;
        }
      }
    }

    .right {
      display: flex;
      align-items: center;
      width: 120px;
      justify-content: right;

      .buttonTimer {
        font-size: 16px;
      }
    }
  }

  .messageInfoArea {
    padding: 40px 24px;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    display: flex;
    flex-direction: column;
    gap: 32px;

    .title {
      font-size: 20px;
    }

    .infoContent {
      display: flex;
      align-items: center;
      gap: 24px;

      .infoItem {
        display: flex;
        line-height: 22px;
        font-size: 16px;

        .label {
          font-size: 16px;
          width: 104px;
        }
        .value {
          font-size: 16px;
          flex: 1;
        }
      }

      .left,
      .right {
        display: flex;
        flex-direction: column;
        gap: 24px;
      }

      .left {
        width: 360px;
      }

      .right {
        flex: 1;
      }
    }
  }

  .warning {
    margin-top: 20px;
    font-size: 12px;
    line-height: 16px;
  }

  .input-line-content {
    .input-line-errorStence {
      height: auto;
      position: static;
      padding-top: 10px;
      .input-line-warning {
        position: static;
        bottom: auto;
        line-height: 16px;
      }
      .input-line-error {
        position: static;
        top: auto;
        line-height: 16px;
      }
    }
  }

  .otcTrade-otcPayIcon {
    cursor: auto;
    font-size: 24px;
  }

  .closeTrade-dialog {
    font-size: 14px;
    padding-bottom: 10px;
  }

  .otcTrade-options-myself {
    padding: 40px 24px;

    .myself-tip {
      font-size: 14px;
      margin-top: 38px;
    }
    .textButton {
      font-size: 14px;
    }
  }

  .otcTrade-options-trade {
    padding: 40px 24px;

    .options-trade-title {
      font-size: 20px;
    }

    .buttonTimer {
      display: inline-block;
      margin-left: 20px;
      font-size: 14px;
    }
    .options-trade-form {
      margin-top: 40px;
      .leftInp,
      .rightInp {
        width: 260px;
        float: left;
      }
      .tradeIcon {
        height: 46px;
        line-height: 96px;
        text-align: center;
        width: 60px;
        float: left;
      }
    }
    .options-trade-pass {
      width: 260px;
      margin-top: 24px;
    }
  }
}
</style>
